import React from "react";
import telesale2 from "../assets/icons/tele-sale.svg";
import email from "../assets/icons/email-ic.svg";
import credit_card from "../assets/icons/credit-card-ic.svg";
import logo from "../assets/logo/Logo-BlueZone.png";
import facebookBadge from "../assets/icons/facebook-badge.svg";
import tiktokBadge from "../assets/icons/tiktok-badge.svg";
import zaloBadge from "../assets/icons/Zalo-Badge.svg";
import arrowUp from "../assets/icons/tabler_arrow-up.svg";
const Footer = () => {
  return (
    <>
      <section className="contact-section">
        <div className="contact-grid">
          <div className="contact-item">
            <div className="contact-icon">
              <img src={telesale2} alt="contact 1" className="creative" />
            </div>
            <div className="contact-content">
              <div className="contact-description">
                Để được tư vấn giải pháp tài chính
              </div>
              <div className="contact-text"> 024 8588 6168</div>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-icon">
              <img src={email} alt="contact 2" className="creative" />
            </div>
            <div className="contact-content">
              <div className="contact-description">Để được hỗ trợ</div>
              <div className="contact-text">info@hitechvietnam.vn</div>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-icon">
              <img src={credit_card} alt="contact 3" className="creative" />
            </div>
            <div className="contact-content">
              <div className="contact-description">
                Sử dụng thêm nhiều tiện ích
              </div>
              <div className="contact-text">Tạo thẻ online ngay!</div>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-column">
            <div className="footer-logo">
              <img src={logo} alt="Blue-zone" height={48} />
            </div>
            <p className="footer-description">
              Bằng công nghệ Big Data tiên tiến, chúng tôi kết nối Khách hàng
              đến với các sản phẩm tài chính phù hợp cùng ưu đãi độc quyền từ
              các Ngân hàng và Tổ chức tài chính lớn nhất Việt Nam.
            </p>
            <p className="footer-disclaimer">
              Blue-zone không phải đơn vị cung cấp và phát hành các sản phẩm tài
              chính. Blue-zone sử dụng nền tảng công nghệ của mình để đánh giá
              các đối tác tài chính uy tín với các sản phẩm vay, thẻ tín dụng đa
              dạng, ưu đãi hấp dẫn để kết nối đến Khách hàng một cách phù hợp và
              nhanh chóng nhất. Blue-zone cung cấp đến cho Khách hàng thông tin
              đầy đủ nhất về điều khoản, điều kiện của tất cả sản phẩm và không
              tính phí sử dụng dịch vụ.
            </p>

            <div className="footer-social">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="social-link"
              >
                <img src={facebookBadge} alt="Facebook" />
              </a>
              <a
                href="https://www.tiktok.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
                className="social-link"
              >
                <img src={tiktokBadge} alt="TikTok" />
              </a>
              <a
                href="https://zalo.me"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Zalo"
                className="social-link"
              >
                <img src={zaloBadge} alt="Zalo" />
              </a>
            </div>
          </div>

          <div className="footer-column">
            <div className="footer-section">
              <h4 className="column-title">CÔNG TY</h4>
              <div className="footer-divider" />
              <ul className="link-list">
                <li className="link-item">Về chúng tôi</li>
                <li>
                  <a href="/tin-tuc" className="link-item">
                    Tin tức
                  </a>
                </li>
                <li>
                  <a href="/lien-he" className="link-item">
                    Liên hệ
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-section">
              <h4 className="column-title">HỖ TRỢ</h4>
              <div className="footer-divider" />
              <ul className="link-list">
                <li className="link-item">Điều kiện điều khoản</li>
                <li className="link-item">An toàn bảo mật</li>
                <li className="link-item">Yêu cầu xóa dữ liệu</li>
              </ul>
            </div>
          </div>

          <div className="footer-column">
            <div className="footer-section">
              <h4 className="column-title">SẢN PHẨM</h4>
              <div className="footer-divider" />
              <ul className="link-list">
                <li>
                  <a href="/dich-vu/vay-online" className="link-item">
                    Vay tiêu dùng
                  </a>
                </li>
                <li>
                  <a href="/dich-vu/mo-the " className="link-item">
                    Thẻ tín dụng
                  </a>
                </li>
                <li className="link-item">Bảo hiểm</li>
                <li className="link-item">Bất động sản</li>
              </ul>
            </div>

            <div className="footer-section">
              <h4 className="column-title">Liên hệ</h4>
              <div className="footer-divider" />
              <div className="contact-info">
                <strong>Công ty Cổ phần Phát triển Hi-Tech Việt Nam</strong>
                Tầng 2, Tòa nhà Handico Tower - Khu đô thị mới Mễ Trì Hạ, đường Phạm Hùng, phường Từ Liêm, thành phố Hà Nội
                <br />
                Email:{" "}
                <a
                  href="mailto:info@hitechvietnam.vn"
                  style={{ color: "#9979E4", textDecoration: "underline" }}
                >
                  info@hitechvietnam.vn
                </a>
              </div>
              <a href="/dich-vu/vay-online/dang-ky-vay" className="footer-cta">
                Hoàn tất đăng ký
                <img src={arrowUp} alt="arrow" className="cta-icon" />
              </a>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyright">
        Bản quyền © 2025 thuộc về Công ty Cổ phần Phát triển Hi-Tech Việt Nam.
        Bảo lưu mọi quyền.
      </div>
    </>
  );
};

export default Footer;
